import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Shield, CheckCircle, Lock, UserCheck } from 'lucide-react';

const TrustSafetyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-6 text-center">Trust & Safety</h1>
        <p className="text-lg text-gray-600 mb-12 text-center">Your security and peace of mind are our top priorities</p>
        
        <div className="space-y-8">
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-start">
              <Shield className="h-10 w-10 text-orange-600 mr-4 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold mb-2">Verified Professionals</h3>
                <p className="text-gray-600">All professionals on our platform undergo verification to ensure they meet our quality standards. We verify business licenses, insurance, and credentials.</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-start">
              <Lock className="h-10 w-10 text-orange-600 mr-4 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold mb-2">Secure Payments</h3>
                <p className="text-gray-600">All payment transactions are processed through Stripe, a secure and trusted payment processor. We never store your credit card information.</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-start">
              <UserCheck className="h-10 w-10 text-orange-600 mr-4 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold mb-2">Reviews & Ratings</h3>
                <p className="text-gray-600">Real customer reviews help you make informed decisions. We verify reviews to ensure authenticity and transparency.</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-start">
              <CheckCircle className="h-10 w-10 text-orange-600 mr-4 flex-shrink-0" />
              <div>
                <h3 className="text-xl font-semibold mb-2">Quality Assurance</h3>
                <p className="text-gray-600">We continuously monitor professional performance and customer satisfaction. Poor performers are removed from our platform.</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-12 bg-orange-50 border border-orange-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold mb-2">Report an Issue</h3>
          <p className="text-gray-700 mb-4">If you experience any problems or have safety concerns, please contact us immediately at support@profind.ca or call 1-800-PROFIND.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TrustSafetyPage;